// ABOUTME: Card component for displaying carrier information in relation portal
// ABOUTME: Shows carrier name, weight, dimensions, safety stock, and total stock
import { Box, useTheme } from "@mui/material"
import BaseCard from "../../../../theme/cards/BaseCard"
import { tokens } from "../../../../../theme";
import Text from "../../../../theme/text/Text";
import { useTranslation } from "react-i18next";
import ShTextSkeleton from "../../../../theme/skeleton/ShTextSkeleton";

const AllRelationCarriersCard = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);

    const pickingStock = props.pickingStock ?? 0;
    const bulkStock = props.bulkStock ?? 0;
    const totalStock = pickingStock + bulkStock;

    return (
        <BaseCard onClick={props.onClick}>
            <Box>
                <Box>
                    <Box display={"flex"} flexDirection={"column"}>
                        <Text bold>{props.name}</Text>
                    </Box>

                    {/* Carrier details */}
                    <Box marginTop={3} display={"flex"} flexDirection={"column"} gap={2}>

                        {/* Dimensions and Weight */}
                        <Box
                            sx={{
                                display:'flex',
                                flexDirection:"column"
                            }}
                        >
                            <Text light>{t("dimensions_lwh")}</Text>
                            {props.skeleton ?
                                <ShTextSkeleton/>
                                :
                                <Text>
                                    {`${props.length} x ${props.width} x ${props.height}`}
                                </Text>
                            }
                        </Box>

                        {/* Weight */}
                        <Box
                            sx={{
                                display:'flex',
                                flexDirection:"column"
                            }}
                        >
                            <Text light>{`${t("weight_including_label")} (${t("gram")})`}</Text>
                            {props.skeleton ?
                                <ShTextSkeleton/>
                                :
                                <Text>
                                    {props.weight}
                                </Text>
                            }
                        </Box>

                        {/* Stock information row */}
                        <Box display={"flex"} justifyContent={"space-between"} gap={2}>
                            {/* Safety Stock */}
                            <Box display={"flex"} flexDirection={"column"}>
                                <Text light>{t("safety_stock")}</Text>
                                {props.skeleton ?
                                    <ShTextSkeleton/>
                                    :
                                    props.safetyStock && props.safetyStock > totalStock ?
                                        <Text bold color={colors.red[400]}>{props.safetyStock}</Text>
                                        :
                                        <Text>{props.safetyStock}</Text>
                                }
                            </Box>

                            {/* Total Stock */}
                            <Box display={"flex"} flexDirection={"column"}>
                                <Text light>{t("stock")}</Text>
                                {props.skeleton ?
                                    <ShTextSkeleton/>
                                    :
                                    <Text>{totalStock}</Text>
                                }
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </BaseCard>
    )
}

export default AllRelationCarriersCard;
